import { Alert } from "react-bootstrap";

type AlertComponentProps = {
  onClose: (close: boolean) => void;
  text: string;
  variant: string;
};

export const AlertComponent = (props: AlertComponentProps) => {
  return (
    <>
      <Alert
        key={props.variant}
        variant={props.variant}
        className="my-3"
        onClose={() => props.onClose(false)}
        dismissible={false}
      >
        {props.text}

        <button
          type="button"
          onClick={() => props.onClose(false)}
          style={{
            position: "absolute",
            top: "0",
            right: "0",
            cursor: "pointer",
          }}
          aria-label="Close"
        >
          &#x2715;
        </button>
      </Alert>
    </>
  );
};
